export default "__VITE_ASSET__$DOGS9TE__"